(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["carruselop"] && !Shopify.designMode) return;
  try {
    
(function(){
  const carousel = document.querySelector('#carousel-{{ section.id }}');
  const dots = document.querySelectorAll('#dots-{{ section.id }} .dot');
  let index = 0;

  function showSlide(i) {
    if (!carousel) return;
    index = i;
    carousel.style.transform = `translateX(-${i * 100}%)`;
    dots.forEach((d, j) => d.classList.toggle('active', j === i));
  }

  dots.forEach((dot, i) => {
    dot.addEventListener('click', () => showSlide(i));
  });

  setInterval(() => {
    index = (index + 1) % dots.length;
    showSlide(index);
  }, 7000);

  showSlide(0);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["carruselvideo"] && !Shopify.designMode) return;
  try {
    
(function () {
  var SELECTOR = '[data-carrusel-videos]';

  function iniciar(seccion) {
    if (seccion.getAttribute('data-cv-listo') === '1') return;
    seccion.setAttribute('data-cv-listo', '1');

    var modal = seccion.querySelector('[data-cv-modal]');
    var modalVideo = seccion.querySelector('[data-cv-modal-video]');
    var cerradores = seccion.querySelectorAll('[data-cv-cerrar]');
    var abribles = seccion.querySelectorAll('[data-cv-abrir]');
    var previos = seccion.querySelectorAll('.carrusel-videos__video');
    var scrollPrevio = '';

    function pausarPreviews() {
      Array.prototype.forEach.call(previos, function (v) {
        try { v.pause(); } catch (e) {}
      });
    }

    function reanudarPreviews() {
      Array.prototype.forEach.call(previos, function (v) {
        try {
          v.muted = true;
          var p = v.play();
          if (p && p.catch) p.catch(function () {});
        } catch (e) {}
      });
    }

    function abrir(src, poster) {
      if (!modal || !modalVideo || !src) return;
      pausarPreviews();
      modalVideo.src = src;
      if (poster) modalVideo.setAttribute('poster', poster);
      modal.classList.add('carrusel-videos__modal--abierto');
      modal.setAttribute('aria-hidden', 'false');
      scrollPrevio = document.documentElement.style.overflow;
      document.documentElement.style.overflow = 'hidden';
      modalVideo.muted = false;
      modalVideo.currentTime = 0;
      var p = modalVideo.play();
      if (p && p.catch) p.catch(function () {});
    }

    function cerrar() {
      if (!modal) return;
      modal.classList.remove('carrusel-videos__modal--abierto');
      modal.setAttribute('aria-hidden', 'true');
      document.documentElement.style.overflow = scrollPrevio;
      try {
        modalVideo.pause();
        modalVideo.removeAttribute('src');
        modalVideo.load();
      } catch (e) {}
      reanudarPreviews();
    }

    Array.prototype.forEach.call(abribles, function (tarjeta) {
      tarjeta.addEventListener('click', function () {
        abrir(tarjeta.getAttribute('data-cv-src'), tarjeta.getAttribute('data-cv-poster'));
      });
      tarjeta.addEventListener('keydown', function (ev) {
        if (ev.key === 'Enter' || ev.key === ' ') {
          ev.preventDefault();
          abrir(tarjeta.getAttribute('data-cv-src'), tarjeta.getAttribute('data-cv-poster'));
        }
      });
    });

    Array.prototype.forEach.call(cerradores, function (el) {
      el.addEventListener('click', cerrar);
    });

    document.addEventListener('keydown', function (ev) {
      if (ev.key === 'Escape' && modal && modal.classList.contains('carrusel-videos__modal--abierto')) {
        cerrar();
      }
    });

    reanudarPreviews();
  }

  function iniciarTodas() {
    Array.prototype.forEach.call(document.querySelectorAll(SELECTOR), iniciar);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', iniciarTodas);
  } else {
    iniciarTodas();
  }

  document.addEventListener('shopify:section:load', function (evento) {
    var seccion = evento.target.querySelector(SELECTOR);
    if (seccion) {
      seccion.removeAttribute('data-cv-listo');
      iniciar(seccion);
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["caruselresenas"] && !Shopify.designMode) return;
  try {
    
(function () {
  var SELECTOR = '[data-carrusel-resenas-img]';

  function iniciar(seccion) {
    if (seccion.getAttribute('data-cri-listo') === '1') return;
    seccion.setAttribute('data-cri-listo', '1');

    var modal = seccion.querySelector('[data-cri-modal]');
    var modalImg = seccion.querySelector('[data-cri-modal-img]');
    var cerradores = seccion.querySelectorAll('[data-cri-cerrar]');
    var abribles = seccion.querySelectorAll('[data-cri-abrir]');
    var scrollPrevio = '';

    function abrir(src) {
      if (!modal || !modalImg || !src) return;
      modalImg.src = src;
      modal.classList.add('carrusel-resenas-img__modal--abierto');
      modal.setAttribute('aria-hidden', 'false');
      scrollPrevio = document.documentElement.style.overflow;
      document.documentElement.style.overflow = 'hidden';
    }

    function cerrar() {
      if (!modal) return;
      modal.classList.remove('carrusel-resenas-img__modal--abierto');
      modal.setAttribute('aria-hidden', 'true');
      document.documentElement.style.overflow = scrollPrevio;
      modalImg.removeAttribute('src');
    }

    Array.prototype.forEach.call(abribles, function (tarjeta) {
      tarjeta.addEventListener('click', function () {
        abrir(tarjeta.getAttribute('data-cri-src'));
      });
      tarjeta.addEventListener('keydown', function (ev) {
        if (ev.key === 'Enter' || ev.key === ' ') {
          ev.preventDefault();
          abrir(tarjeta.getAttribute('data-cri-src'));
        }
      });
    });

    Array.prototype.forEach.call(cerradores, function (el) {
      el.addEventListener('click', cerrar);
    });

    document.addEventListener('keydown', function (ev) {
      if (ev.key === 'Escape' && modal && modal.classList.contains('carrusel-resenas-img__modal--abierto')) {
        cerrar();
      }
    });
  }

  function iniciarTodas() {
    Array.prototype.forEach.call(document.querySelectorAll(SELECTOR), iniciar);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', iniciarTodas);
  } else {
    iniciarTodas();
  }

  document.addEventListener('shopify:section:load', function (evento) {
    var seccion = evento.target.querySelector(SELECTOR);
    if (seccion) {
      seccion.removeAttribute('data-cri-listo');
      iniciar(seccion);
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["resenass"] && !Shopify.designMode) return;
  try {
    
(function () {
  var SELECTOR = '[data-resenas-fotos]';

  function iniciar(seccion) {
    if (seccion.getAttribute('data-rf-listo') === '1') return;
    seccion.setAttribute('data-rf-listo', '1');
    var lote = parseInt(seccion.getAttribute('data-lote'), 10) || 6;
    var textoMas = seccion.getAttribute('data-texto-ver-mas') || 'Ver más';
    var textoMenos = seccion.getAttribute('data-texto-ver-menos') || 'Ver menos';
    var boton = seccion.querySelector('[data-rf-boton]');
    var temporizador = null;

    function ajustarTarjeta(tarjeta) {
      if (tarjeta.classList.contains('resenas-fotos__tarjeta--expandida')) return;
      var texto = tarjeta.querySelector('[data-rf-texto]');
      var alternar = tarjeta.querySelector('[data-rf-alternar]');
      if (!texto || !alternar) return;
      var desborda = texto.scrollHeight > texto.clientHeight + 1;
      alternar.classList.toggle('resenas-fotos__alternar--visible', desborda);
    }

    function ajustarVisibles() {
      var tarjetas = seccion.querySelectorAll('.resenas-fotos__tarjeta:not(.resenas-fotos__tarjeta--oculta)');
      Array.prototype.forEach.call(tarjetas, ajustarTarjeta);
    }

    Array.prototype.forEach.call(seccion.querySelectorAll('[data-rf-alternar]'), function (alternar) {
      alternar.addEventListener('click', function () {
        var tarjeta = alternar.closest('.resenas-fotos__tarjeta');
        if (!tarjeta) return;
        var expandida = tarjeta.classList.toggle('resenas-fotos__tarjeta--expandida');
        alternar.textContent = expandida ? textoMenos : textoMas;
        alternar.setAttribute('aria-expanded', expandida ? 'true' : 'false');
        if (!expandida) ajustarTarjeta(tarjeta);
      });
    });

    if (boton) {
      boton.addEventListener('click', function () {
        var ocultas = seccion.querySelectorAll('.resenas-fotos__tarjeta--oculta');
        var limite = Math.min(lote, ocultas.length);
        for (var i = 0; i < limite; i++) {
          ocultas[i].classList.remove('resenas-fotos__tarjeta--oculta');
          ajustarTarjeta(ocultas[i]);
        }
        if (seccion.querySelectorAll('.resenas-fotos__tarjeta--oculta').length === 0) {
          boton.classList.add('resenas-fotos__boton--oculto');
        }
      });
    }

    window.addEventListener('resize', function () {
      clearTimeout(temporizador);
      temporizador = setTimeout(ajustarVisibles, 150);
    });

    ajustarVisibles();
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(ajustarVisibles);
    }
  }

  function iniciarTodas() {
    Array.prototype.forEach.call(document.querySelectorAll(SELECTOR), iniciar);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', iniciarTodas);
  } else {
    iniciarTodas();
  }

  document.addEventListener('shopify:section:load', function (evento) {
    var seccion = evento.target.querySelector(SELECTOR);
    if (seccion) iniciar(seccion);
  });
})();

  } catch(e) { console.error(e); }
})();
})();
